import { render, staticRenderFns } from "./ProfileItem.vue?vue&type=template&id=03bdabe7&"
import script from "./ProfileItem.vue?vue&type=script&lang=js&"
export * from "./ProfileItem.vue?vue&type=script&lang=js&"
import style0 from "./ProfileItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports